import { sedativesServices } from '@/services/db'

const state = {
  sedatives: [],
  sedativesListFormat: []
}

// getters
const getters = {
  getSedatives: state => state.sedatives,
  getSedativesListFormat: state => state.sedativesListFormat,
}

// actions
const actions = {

  async fetchSedatives ({commit}, payload) {
    try {
      commit('setLoading', true, { root: true })

      const res = await sedativesServices.fetchSedatives(payload)
      const list = []
      res.forEach((v,i) => {
        list.push({text:v.sedative,value:v.id})  
      })
    
      commit('setSedativesListFormat', list)
      commit('setSedatives', res)
      commit('setLoading', false, { root: true })
    } catch (e) {
      void 0
    }
  },

  async updateColumnById ({commit}, payload) {
    /*************************************
    * ID: sedative Id                      *
    * field: the field that changed      *
    * value: the new value of that field *
    *************************************/
    
    try {
      commit('setLoading', true, { root: true })

      /* API call here to save data to server */
      /* code here */

      const res = await sedativesServices.updateSedativeColumn(payload)

      commit('setLoading', false, { root: true })
    } catch (e) { 
      void 0
    }
  },

  async addSedative ({commit}) {
    try {
      commit('setLoading', true, { root: true })

      /* API call here to server to create new sedative */
      /* code here */

      let obj = {
        name: 'New Sedative'
      }

      const res = await sedativesServices.addSedative(obj)
      const data = await Promise.resolve([
        ...state.sedatives,
        res.data
      ])
      commit('setSedatives', data)
      commit('setLoading', false, { root: true })
    } catch (e) { 
      void 0
    }
  },
  async sortSedative({commit}, payload){
    commit('setLoading', true, { root: true })
    let title = payload.title;
    let order = payload.order

    let data = []
    if (order){
      data= state.sedatives.sort((a,b) => a[title].toString().localeCompare(b[title].toString()))
    }else{
      data= state.sedatives.sort((b,a) => a[title].toString().localeCompare(b[title].toString()))
    }
    commit('setSedatives', data)
    commit('setLoading', false, { root: true })
  }

}

// mutations
const mutations = {
  resetSedatives (state) {
    state.sedatives = []
  },

  setSedatives (state, payload) {
    state.sedatives = payload
  },

  setSedativesListFormat (state, payload) {
    state.sedativesListFormat = payload
  }

  
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}